import React from 'react';
import { InfinityIcon, TruckIcon } from 'lucide-react';
import { PromoCountdown } from './PromoCountdown';
import { useActiveSale } from '../hooks/useActiveSale';
import { pricing } from '../data/promotion';
import { money } from './QuantityStepper';

/**
 * The single offer banner above the cover: sale name, price, the two
 * multi-pack perks and the weekly countdown. Links to the packs.
 */
export function AnnouncementBar() {
  const sale = useActiveSale();
  return <a href="#offer" className="block w-full bg-grit-500 text-ink-950 transition-colors duration-150 ease-grit hover:bg-grit-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ink-950" data-id="element-13" data-mp="5uc12bspn0c6">
      <div className="mx-auto flex max-w-[1400px] flex-col items-center gap-1.5 px-4 py-2 lg:flex-row lg:justify-between lg:gap-6 lg:px-8" data-id="element-14" data-mp="3s2kcka5vny6i">
        <p className="flex flex-wrap items-baseline justify-center gap-x-2.5 gap-y-1 text-center" data-id="element-15" data-mp="1v761ho80c0i9">
          <span className="font-display text-lg font-extrabold uppercase leading-none tracking-wide sm:text-xl" data-id="element-16" data-mp="1q82va0gajo8p">
            <span aria-hidden="true" data-id="element-17" data-mp="a9vf44c265oh">★ </span>
            {sale.name}
          </span>
          {sale.years && <span className="whitespace-nowrap text-[10px] font-extrabold uppercase tracking-[0.16em] text-ink-950/70 sm:text-[11px]" data-id="element-18" data-mp="3sfq96h149h67">
              {sale.years}
            </span>}
          <span className="whitespace-nowrap bg-ink-950 px-1.5 py-0.5 font-display text-base font-extrabold uppercase leading-none text-grit-500" data-id="element-19" data-mp="oyrny3lxvmq5">
            Save {money(pricing.save).replace('.00', '')}
          </span>
          <span className="whitespace-nowrap font-display text-base font-bold leading-none" data-id="element-20" data-mp="f9q6sa3nqzal">
            <span className="sr-only" data-id="element-21" data-mp="k7hu0qtcxx8g">Regular price </span>
            <span className="text-ink-950/55 line-through" data-id="element-22" data-mp="k5yej2fizq7q">{money(pricing.regular)}</span>{' '}
            {money(pricing.launch)}
          </span>
        </p>

        <p className="flex flex-wrap items-center justify-center gap-x-4 gap-y-0.5 text-[10px] font-extrabold uppercase tracking-[0.14em] sm:text-[11px]" data-id="element-23" data-mp="1cpdq5e99ics8">
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-24" data-mp="1hl81u7amdib2">
            <TruckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="1hm14aw2jplne" />
            Free shipping on $99.90+
          </span>
          <span className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-26" data-mp="18kjozfwypnzr">
            <InfinityIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-27" data-mp="18k9zdtftxiul" />
            Lifetime guarantee on multi-packs
          </span>
        </p>

        <PromoCountdown compact className="whitespace-nowrap bg-ink-950 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-grit-500 sm:text-[11px]" data-id="element-28" data-mp="yu88yv007oci" />
      </div>
    </a>;
}